"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var Thumbnail = function (_a) {
    var image = _a.image, onChange = _a.onChange, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onErrors = _a.onErrors;
    var preview = image && typeof image === 'object' ? image.preview : image;
    var style = preview ? { backgroundImage: "url(" + preview + ")" } : {};
    return react_1.default.createElement("div", { className: "storybook-forms-thumbnail " + (!disabled ? 'cursor-pointer' : ''), style: style }, style && react_1.default.createElement("div", { className: 'storybook-forms-thumbnail-overlay' },
        !disabled && react_1.default.createElement("input", { className: 'storybook-forms-thumbnail-upload', type: 'file', onChange: function (event) {
                var file = event.target.files[0];
                // if (file.size > 2000000) {
                //     return onErrors([{
                //         message: 'Thumbnail mag niet groter zijn dan 2 mb.'
                //     }])
                // } else {
                //     onErrors([])
                // }
                file.preview = URL.createObjectURL(file);
                onChange(file);
            } }),
        !disabled && react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: 'storybook-forms-thumbnail-icon' },
                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'camera', className: 'storybook-icons-icon' })),
            react_1.default.createElement(storybook_1.Texts.Primary, { className: 'storybook-forms-thumbnail-text' }, label ? label : 'Thumbnail vervangen'))));
};
exports.Thumbnail = Thumbnail;
exports.Thumbnail.propTypes = {
    image: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
    onChange: prop_types_1.default.func,
};
exports.Thumbnail.defaultProps = {};
